<div class="create-dsp-source">
  <div class="create-dsp-source__header" *nzModalTitle>
    <h2 id="createDspSourceTitle" class="create-dsp-source__title">
      New DSP Source Schain
    </h2>
    <div class="create-dsp-source__close">
      <span
        nz-icon
        nzType="close"
        nzTheme="outline"
        style="color: #002199; font-size: 16px"
        (click)="onCloseModal()"
      ></span>
    </div>
  </div>

  <div class="create-dsp-source__body-wrapper">
    <div
      class="create-dsp-source__body"
      [formGroup]="createSchainService.newSSPSourceForm"
    >
      <div class="create-dsp-source__left">
        <div class="create-dsp-source__card">
          <h3 class="create-dsp-source__subtitle">General</h3>

          <div class="create-dsp-source__requirements">
            <div class="create-dsp-source__requirements-title">
              Source Schain file requirements:
            </div>
            <ul class="create-dsp-source__requirements-list">
              <li class="create-dsp-source__requirements-item">
                <b>File type:</b> Only CSV and TXT files are supported
              </li>
              <li class="create-dsp-source__requirements-item">
                <b>Required columns:</b> headers must be exactly named: bundle
                ID, SID, ASI
              </li>
              <li class="create-dsp-source__requirements-item">
                <b>Optional column:</b> if included, header must be exactly
                named: inventorypartnerdomain
              </li>
              <li class="create-dsp-source__requirements-item">
                <b>File size limit:</b> Maximum 15 MB
              </li>
              <li class="create-dsp-source__requirements-item">
                <b>Row limit:</b> {{ rowLimitDescription }}
              </li>
            </ul>
          </div>

          <label class="create-dsp-source__label" for="fileName"
            >File Name</label
          >
          <input
            nz-input
            type="text"
            class="create-dsp-source__input"
            formControlName="fileName"
            placeholder="Add File Name"
          />

          <div class="create-dsp-source__actions">
            <div class="card-column">
              <div
                class="card-bottom"
                [ngSwitch]="createSchainService.isShowFileName"
              >
                <div
                  class="card-bottom__progress progress-content"
                  *ngSwitchCase="false"
                >
                  <div
                    class="progress-content__result result-content"
                    *ngIf="createSchainService.progress === 0"
                  >
                    <div class="result-content__name">
                      <p class="result-content__title">Actions</p>
                    </div>
                    <div class="result-content__buttons buttons-content">
                      <div class="buttons-content__row">
                        <div class="buttons-content__column">
                          <button
                            nz-button
                            nzType="default"
                            class="btn-upload"
                            type="button"
                            (click)="fileInput.click()"
                          >
                            <span nz-icon nzType="ng-zorro:uploadFile"></span>
                            <input
                              type="file"
                              #fileInput
                              (change)="onUploadFile($event)"
                            />
                          </button>
                        </div>
                        <div class="buttons-content__column">
                          <button
                            nz-button
                            nzType="default"
                            class="btn-download"
                            type="button"
                            (click)="onDownloadFile()"
                            [disabled]="
                              createSchainService.uploadedFileName === ''
                            "
                          >
                            <span nz-icon nzType="ng-zorro:downloadFile"></span>
                          </button>
                        </div>
                        <div class="buttons-content__column">
                          <button
                            nz-button
                            nzType="default"
                            class="btn-delete"
                            type="button"
                            (click)="onDeleteFile()"
                            [disabled]="
                              createSchainService.uploadedFileName === ''
                            "
                          >
                            <span nz-icon nzType="ng-zorro:deleteFile"></span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="progress-content__bar content-wrapper"
                    *ngIf="createSchainService.progress > 0"
                  >
                    <div class="content-wrapper_bar">
                      <div class="content-wrapper__progress">
                        <nz-progress
                          *ngIf="createSchainService.onShowProgress"
                          [nzPercent]="createSchainService.progress"
                          [nzStatus]="createSchainService.uploadStatus"
                        ></nz-progress>
                      </div>
                    </div>
                    <div
                      class="content-wrapper__button"
                      *ngIf="createSchainService.onShowCancelButton"
                    >
                      <div class="btn-cancel">
                        <span
                          nz-icon
                          nzType="ng-zorro:cancelAdmin"
                          (click)="onCancelUpload()"
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="card-bottom__result result-content"
                  *ngSwitchCase="true"
                >
                  <div class="result-content__name">
                    <p class="result-content__filename">
                      <span nz-icon nzType="ng-zorro:uploadFileBar"></span>
                      <span class="result-content__text"
                        >{{ createSchainService.uploadedFileName }}
                      </span>
                    </p>
                  </div>
                  <div class="result-content__buttons buttons-content">
                    <div class="buttons-content__row">
                      <div class="buttons-content__column">
                        <button
                          nz-button
                          nzType="default"
                          class="btn-upload"
                          type="button"
                          (click)="fileInput.click()"
                        >
                          <span nz-icon nzType="ng-zorro:uploadFile"></span>
                          <input
                            type="file"
                            #fileInput
                            (change)="onUploadFile($event)"
                          />
                        </button>
                      </div>
                      <div class="buttons-content__column">
                        <span
                          nz-icon
                          nzType="ng-zorro:downloadFile"
                          (click)="onDownloadFile()"
                        ></span>
                      </div>
                      <div class="buttons-content__column">
                        <span
                          nz-icon
                          nzType="ng-zorro:deleteFile"
                          (click)="onDeleteFile()"
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="create-dsp-source__tips">
            <p class="create-dsp-source__tip">
              To activate DSP Source Chain matching, you first need to upload a
              file. After the upload, go to your DSP endpoint settings and
              select the file from the dropdown menu with all available DSP-side
              files. Before activating Source Chain matching, we strongly
              recommend:
            </p>
            <ol class="create-dsp-source__recommendations">
              <li>
                <span>Set up a Filter List</span> that allows only the same
                sources included in your uploaded file.
              </li>
              <li>
                If a request contains a source that is not listed in your file,
                the system will not use the file for matching, and the
                <span>default platform Schain node will be applied.</span>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="create-dsp-source__footer" *nzModalFooter>
    <button
      nz-button
      type="button"
      nzType="primary"
      class="button-create"
      (click)="onCreateDspSource()"
      [disabled]="createSchainService.uploadedFileName === ''"
    >
      Create
    </button>
    <button
      nz-button
      type="button"
      nzType="default"
      class="button-cancel"
      (click)="onCloseModal()"
      [disabled]="createSchainService.isDisabledCancelButton()"
    >
      Cancel
    </button>
  </div>
</div>
